export type DashboardRenderState = 'loading' | 'error' | 'missing' | 'ready';

export function getDashboardRenderState(opts: {
  loading: boolean;
  error: string | null;
  hasLeague: boolean;
}): DashboardRenderState {
  if (opts.loading) return 'loading';
  if (opts.error) return 'error';
  if (!opts.hasLeague) return 'missing';
  return 'ready';
}
